import React from 'react';
import { MenuItem, Box, MenuItemProps as ChakraMenuItemProps } from '@chakra-ui/core';
import colors from '../../styles/colors';

type CustomMenuProps = ChakraMenuItemProps & {
  id: string;
  icon: React.ReactNode;
  label: string;
  handleClick: () => void;
  testId: string;
  isBtnDisabled?: boolean;
};

export const CustomMenuItem = ({
  id,
  icon,
  label,
  handleClick,
  testId,
  isBtnDisabled,
  ...rest
}: CustomMenuProps): JSX.Element => {
  return (
    <MenuItem
      id={id}
      minH="48px"
      _focus={{ bg: colors.blue['700'] }}
      borderRadius={3}
      data-testid={testId}
      onClick={handleClick}
      isDisabled={isBtnDisabled}
      {...rest}
    >
      <Box pr="12px">{icon}</Box>
      {label}
    </MenuItem>
  );
};

CustomMenuItem.defaultProps = {
  isBtnDisabled: false,
};
